// Major US cities mapped to their primary county FIPS code.
// Used to auto-suggest the relevant county when a user types a city name.
const US_CITY_COUNTIES = [
    { city: 'New York City', fips: '36061' },
    { city: 'New York', fips: '36061' },
    { city: 'Manhattan', fips: '36061' },
    { city: 'Brooklyn', fips: '36047' },
    { city: 'Queens', fips: '36081' },
    { city: 'Bronx', fips: '36005' },
    { city: 'Staten Island', fips: '36085' },
    { city: 'Los Angeles', fips: '06037' },
    { city: 'Long Beach', fips: '06037' },
    { city: 'Palmdale', fips: '06037' },
    { city: 'Pomona', fips: '06037' },
    { city: 'Pasadena CA', fips: '06037' },
    { city: 'Glendale CA', fips: '06037' },
    { city: 'Chicago', fips: '17031' },
    { city: 'Naperville', fips: '17043' },
    { city: 'Peoria IL', fips: '17143' },
    { city: 'Rockford', fips: '17201' },
    { city: 'Houston', fips: '48201' },
    { city: 'Pasadena TX', fips: '48201' },
    { city: 'Phoenix', fips: '04013' },
    { city: 'Mesa', fips: '04013' },
    { city: 'Chandler', fips: '04013' },
    { city: 'Scottsdale', fips: '04013' },
    { city: 'Glendale AZ', fips: '04013' },
    { city: 'Glendale', fips: '04013' },
    { city: 'Gilbert', fips: '04013' },
    { city: 'Tempe', fips: '04013' },
    { city: 'Peoria AZ', fips: '04013' },
    { city: 'Surprise', fips: '04013' },
    { city: 'Philadelphia', fips: '42101' },
    { city: 'Pittsburgh', fips: '42003' },
    { city: 'San Antonio', fips: '48029' },
    { city: 'San Diego', fips: '06073' },
    { city: 'Escondido', fips: '06073' },
    { city: 'Dallas', fips: '48113' },
    { city: 'Garland', fips: '48113' },
    { city: 'Mesquite', fips: '48113' },
    { city: 'Irving', fips: '48113' },
    { city: 'San Jose', fips: '06085' },
    { city: 'Sunnyvale', fips: '06085' },
    { city: 'Austin', fips: '48453' },
    { city: 'Jacksonville', fips: '12031' },
    { city: 'Fort Worth', fips: '48439' },
    { city: 'Arlington', fips: '48439' },
    { city: 'Columbus', fips: '39049' },
    { city: 'Charlotte', fips: '37119' },
    { city: 'Indianapolis', fips: '18097' },
    { city: 'San Francisco', fips: '06075' },
    { city: 'Seattle', fips: '53033' },
    { city: 'Denver', fips: '08031' },
    { city: 'Nashville', fips: '47037' },
    { city: 'Oklahoma City', fips: '40109' },
    { city: 'El Paso', fips: '48141' },
    { city: 'Las Vegas', fips: '32003' },
    { city: 'Henderson', fips: '32003' },
    { city: 'North Las Vegas', fips: '32003' },
    { city: 'Louisville', fips: '21111' },
    { city: 'Memphis', fips: '47157' },
    { city: 'Portland', fips: '41051' },
    { city: 'Baltimore', fips: '24510' },
    { city: 'Milwaukee', fips: '55079' },
    { city: 'Albuquerque', fips: '35001' },
    { city: 'Tucson', fips: '04019' },
    { city: 'Fresno', fips: '06019' },
    { city: 'Sacramento', fips: '06067' },
    { city: 'Elk Grove', fips: '06067' },
    { city: 'Atlanta', fips: '13121' },
    { city: 'Kansas City', fips: '29095' },
    { city: 'Omaha', fips: '31055' },
    { city: 'Colorado Springs', fips: '08041' },
    { city: 'Raleigh', fips: '37183' },
    { city: 'Virginia Beach', fips: '51810' },
    { city: 'Minneapolis', fips: '27053' },
    { city: 'Tampa', fips: '12057' },
    { city: 'New Orleans', fips: '22071' },
    { city: 'Bakersfield', fips: '06029' },
    { city: 'Honolulu', fips: '15003' },
    { city: 'Anaheim', fips: '06059' },
    { city: 'Santa Ana', fips: '06059' },
    { city: 'Garden Grove', fips: '06059' },
    { city: 'Lancaster', fips: '06037' },
    { city: 'Aurora', fips: '08005' },
    { city: 'Corpus Christi', fips: '48355' },
    { city: 'Riverside', fips: '06065' },
    { city: 'Moreno Valley', fips: '06065' },
    { city: 'Corona', fips: '06065' },
    { city: 'St. Louis', fips: '29510' },
    { city: 'Saint Louis', fips: '29510' },
    { city: 'Lexington', fips: '21067' },
    { city: 'Stockton', fips: '06077' },
    { city: 'Anchorage', fips: '02020' },
    { city: 'Cincinnati', fips: '39061' },
    { city: 'St. Paul', fips: '27123' },
    { city: 'Saint Paul', fips: '27123' },
    { city: 'Greensboro', fips: '37081' },
    { city: 'Toledo', fips: '39095' },
    { city: 'Newark', fips: '34013' },
    { city: 'Plano', fips: '48085' },
    { city: 'Orlando', fips: '12095' },
    { city: 'Laredo', fips: '48479' },
    { city: 'Norfolk', fips: '51710' },
    { city: 'Madison', fips: '55025' },
    { city: 'Durham', fips: '37063' },
    { city: 'Lubbock', fips: '48303' },
    { city: 'Winston-Salem', fips: '37067' },
    { city: 'Baton Rouge', fips: '22033' },
    { city: 'Jersey City', fips: '34017' },
    { city: 'Buffalo', fips: '36029' },
    { city: 'Detroit', fips: '26163' },
    { city: 'Boston', fips: '25025' },
    { city: 'Miami', fips: '12086' },
    { city: 'Hialeah', fips: '12086' },
    { city: 'Salt Lake City', fips: '49035' },
    { city: 'Birmingham', fips: '01073' },
    { city: 'Huntsville', fips: '01089' },
    { city: 'Montgomery', fips: '01101' },
    { city: 'Little Rock', fips: '05119' },
    { city: 'Fayetteville', fips: '05143' },
    { city: 'Springdale', fips: '05143' },
    { city: 'Providence', fips: '44007' },
    { city: 'Richmond', fips: '51760' },
    { city: 'Spokane', fips: '53063' },
    { city: 'Des Moines', fips: '19153' },
    { city: 'Jackson', fips: '28049' },
    { city: 'Knoxville', fips: '47093' },
    { city: 'Chattanooga', fips: '47065' },
    { city: 'Clarksville', fips: '47125' },
    { city: 'Fort Wayne', fips: '18003' },
    { city: 'Reno', fips: '32031' },
    { city: 'Boise', fips: '16001' },
    { city: 'Akron', fips: '39153' },
    { city: 'Grand Rapids', fips: '26081' },
    { city: 'Shreveport', fips: '22017' },
    { city: 'Metairie', fips: '22051' },
    { city: 'Tacoma', fips: '53053' },
    { city: 'Vancouver', fips: '53011' },
    { city: 'Augusta', fips: '13245' },
    { city: 'Savannah', fips: '13051' },
    { city: 'Macon', fips: '13021' },
    { city: 'Oxnard', fips: '06111' },
    { city: 'Fontana', fips: '06071' },
    { city: 'Yonkers', fips: '36119' },
    { city: 'Fremont', fips: '06001' },
    { city: 'Hayward', fips: '06001' },
    { city: 'Modesto', fips: '06099' },
    { city: 'Tallahassee', fips: '12073' },
    { city: 'Cape Coral', fips: '12071' },
    { city: 'Fort Lauderdale', fips: '12011' },
    { city: 'Hollywood', fips: '12011' },
    { city: 'Pembroke Pines', fips: '12011' },
    { city: 'Worcester', fips: '25027' },
    { city: 'Springfield MA', fips: '25013' },
    { city: 'Sioux Falls', fips: '46099' },
    { city: 'Fort Collins', fips: '08069' },
    { city: 'Roseville', fips: '06061' },
    { city: 'Bridgeport', fips: '09001' },
    { city: 'Alexandria', fips: '51510' },
    { city: 'Columbia', fips: '45079' },
    { city: 'Paterson', fips: '34031' },
    { city: 'Killeen', fips: '48027' },
    { city: 'Brownsville', fips: '48061' },
    { city: 'Beaumont', fips: '48245' },
    { city: 'Springfield', fips: '29077' },
    { city: 'Wichita', fips: '20173' },
    { city: 'Kansas City KS', fips: '20091' },
    { city: 'Overland Park', fips: '20091' },
    { city: 'Olathe', fips: '20091' },
    { city: 'Tulsa', fips: '40143' },
    { city: 'Syracuse', fips: '36067' },
    { city: 'Salinas', fips: '06053' },
    { city: 'Provo', fips: '49049' },
    { city: 'Eugene', fips: '41039' },
    { city: 'Salem', fips: '41047' },
    { city: 'Flint', fips: '26049' },
    { city: 'Lansing', fips: '26065' },
    { city: 'Ann Arbor', fips: '26161' },
];

export function searchCitiesForCounty(query, limit = 5) {
    if (!query || query.length < 2) return [];
    const q = query.toLowerCase().trim();
    if (q.length < 2) return [];
    const seen = new Set();
    const results = [];
    // Starts-with matches first (higher relevance)
    for (let i = 0; i < US_CITY_COUNTIES.length && results.length < limit; i++) {
        const c = US_CITY_COUNTIES[i];
        const key = `${c.city.toLowerCase()}|${c.fips}`;
        if (!seen.has(key) && c.city.toLowerCase().startsWith(q)) {
            seen.add(key);
            results.push(c);
        }
    }
    // Then contains matches
    for (let i = 0; i < US_CITY_COUNTIES.length && results.length < limit; i++) {
        const c = US_CITY_COUNTIES[i];
        const key = `${c.city.toLowerCase()}|${c.fips}`;
        if (!seen.has(key) && c.city.toLowerCase().includes(q)) {
            seen.add(key);
            results.push(c);
        }
    }
    return results;
}

export default US_CITY_COUNTIES;
